import axios from './axiosConfig';

export const getHardwareUsage = async () => {
    try {
        const response = await axios.get('/api/hardware-usage');
        console.log('✅ Hardware Usage Data:', response.data); // 打印 API 返回的数据
        return response.data;
    } catch (error) {
        console.error('❌ Failed to fetch hardware usage:', error);
        return null;
    }
};

